module.exports = __webpack_public_path__ + "img/144.2.fb3115a2.png";